<template>
  <section class="product-related"
           v-if="product.related[type] && product.related[type].length > 0"
  >

    <!-- Configurator -->
    <configurator v-for="related in product.related[type]"
                  v-if="related.custom_options && related.custom_options.length > 0"
                  :product="related"
                  :key="related.sku"
    />
    <!---->

    <!-- Header -->
    <div class="product-related-line">
      <h1 class="product-related-line-title">
        {{ heading }}
        <router-link :to="category"
                     class="product-related-line-link no-underline"
        > {{ categoryProduct }} </router-link>
      </h1>
    </div>
    <!---->

    <!-- Slider -->
    <products-swiper columns="4" :products="product.related[type]" />
    <!---->

  </section>
</template>

<script>
import ProductsSwiper from 'theme/components/core/blocks/Shop/Product/ProductsSwiper'
import Configurator from 'theme/components/theme/blocks/Home/ProductTileGrid/Configurator'
import { productsBySkus } from '@vue-storefront/core/lib/catalogSearch'
import i18n from '@vue-storefront/i18n'
import config from 'config'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductRelated',
  props: {
    type: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      required: false,
      default: i18n.t('More from the section')
    }
  },
  components: {
    Configurator,
    ProductsSwiper
  },
  watch: {
    categoryProduct: {
      deep: true,
      handler: function () {
        this.refreshList()
      }
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-load', this.refreshList)
    if (config.usePriceTiers) {
      this.$bus.$on('user-after-loggedin', this.refreshList)
      this.$bus.$on('user-after-logout', this.refreshList)
    }
    this.refreshList()
  },
  beforeDestroy () {
    if (config.usePriceTiers) {
      this.$bus.$off('user-after-loggedin', this.refreshList)
      this.$bus.$off('user-after-logout', this.refreshList)
    }
  },
  destroyed () {
    this.$bus.$off('product-after-load', this.refreshList)
    this.$store.dispatch('product/related', {
      key: this.type,
      items: []
    })
  },
  methods: {
    refreshList () {
      if (this.product.current.partner_code !== this.currentPartner.code) {
        this.$store.dispatch('partners/changeCurrentPartner', this.product.current.partner_code)
      }
      let sku = this.productLinks ? this.productLinks.filter(pl => pl.link_type === this.type).map(pl => pl.linked_product_sku) : null
      let key = 'sku'
      if (sku === null || (sku.length === 0)) {
        if (this.currentPartner && this.currentPartner.display_mode === 'shop') {
          if (this.closestCategory) {
            sku = this.closestCategory.category_id
          } else {
            sku = this.currentPartner.root_category_id
          }
        } else {
          sku = this.product.current.category.map(cat => cat.category_id)
        }
        key = 'category_ids'
      }

      // sku is a bare number (not an array) in the shop-display-mode category_ids branch
      // above (closestCategory/root_category_id) - only the food-mode fallback is already an
      // array. productsBySkus() always needs an array.
      const skuOrCategoryIds = Array.isArray(sku) ? sku : [sku]

      this.$store.dispatch('product/list', {
        semanticFetch: () => productsBySkus(key === 'sku' ? { skus: skuOrCategoryIds, size: 6 } : { categoryIds: skuOrCategoryIds, size: 6 }),
        size: 6,
        prefetchGroupProducts: false,
        updateState: false
      }).then((response) => {
        if (response) {
          // Tag for add-to-cart/purchase attribution (K2-3012) - distinct from the PDP
          // Recommendations.vue types since this is a different slider/surface.
          response.items.forEach(item => { item.recommended = 'section_related' })
          this.$store.dispatch('product/related', {
            key: this.type,
            items: response.items
          })
          this.$forceUpdate()
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner',
      getCurrentPartnerCode: 'partners/getCurrentPartnerCode'
    }),
    categoriesAmount () {
      return this.product.current.category_ids.length
    },
    closestCategory () {
      if (this.categoriesAmount) {
        let category_id = this.product.current.category_ids[this.categoriesAmount - 1]
        return this.product.current.category.find(category => category.category_id === category_id)
      }
      return {}
    },
    products () {
      return this.product.related[this.type]
    },
    product () {
      return this.$store.state.product
    },
    productLinks () {
      return this.product.current.product_links
    },
    category () {
      return `/${this.currentLocation.code}/${this.getCurrentPartnerCode}/${this.urlCategory}`
    },
    categoryProduct () {
      return this.closestCategory.name;
    },
    urlCategory () {
      if (!this.closestCategory.url_path) {
        if (this.$store.state.category.current_path.length > 0) {
          let numberMass = this.$store.state.category.current_path.length;
          return this.$store.state.category.current_path[numberMass - 1].url_path;
        }
      }
      return this.closestCategory.url_path
    }
  }
}
</script>
<style lang="scss" scoped>
.product-related {
  width: 100%;

  display: flex;
  flex-direction: column;

  &-line {
    width: 100%;
    margin: 15px 0;

    display: flex;
    justify-content: space-between;
    align-items: center;

    &-title {
      margin: 0;

      color: #111;
      font-size: 18px;
      font-weight: 600;
      z-index: 2;
    }

    &-link {
      color: #11bb2e;
      text-transform: lowercase;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
